/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TooltipPersistentComponent} from './tooltip-persistent.component';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [TooltipPersistentComponent],
    exports: [
        TooltipPersistentComponent
    ],
    imports: [
        CommonModule,
        NgbModule,
        TooltipModule
    ]
})
export class TooltipPersistentModule {
}
